// en, de, fr, pt

import i18nDataForESM from './i18nDataForESM'

const old_language = {
  en: {
    Dashboard: 'Dashboard',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Todo',
    Chat: 'Chat',
    Email: 'Email',
    Calendar: 'Calendar',
    FullCalendar: 'Full Calendar',
    SimpleCalendar: 'Simple Calendar',
    Shop: 'Shop',
    ItemDetails: 'Item Details',
    Cart: 'Cart',
    WishList: 'Wish List',
    Checkout: 'Checkout',
    UI: 'UI',
    DataList: 'Data List',
    ListView: 'List View',
    ThumbView: 'Thumb View',
    Grid: 'Grid',
    ESM: 'ESM',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Colors',
    Card: 'Card',
    Basic: 'Basic',
    Statistics: 'Statistics',
    Analytics: 'Analytics',
    CardActions: 'Card Actions',
    CardColors: 'Card Colors',
    Table: 'Table',
    agGridTable: 'agGrid Table',
    Components: 'Components',
    Alert: 'Alert',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Button',
    ButtonGroup: 'Button Group',
    Chip: 'Chip',
    Collapse: 'Collapse',
    Dialogs: 'Dialogs',
    Divider: 'Divider',
    DropDown: 'DropDown',
    List: 'List',
    Loading: 'Loading',
    Navbar: 'Navbar',
    Notifications: 'Notifications',
    Pagination: 'Pagination',
    Popup: 'Popup',
    Progress: 'Progress',
    Sidebar: 'Sidebar',
    Slider: 'Slider',
    Tabs: 'Tabs',
    Tooltip: 'Tooltip',
    Upload: 'Upload',
    FormsAndTable: 'Forms & Table',
    FormElements: 'Form Elements',
    Select: 'Select',
    Switch: 'Switch',
    Checkbox: 'Checkbox',
    Radio: 'Radio',
    Input: 'Input',
    NumberInput: 'Number Input',
    Textarea: 'Textarea',
    FormLayouts: 'Form Layouts',
    FormWizard: 'Form Wizard',
    FormValidation: 'Form Validation',
    FormInputGroup: 'Form Input Group',
    Pages: 'Pages',
    Authentication: 'Authentication',
    Login: 'Login',
    Register: 'Register',
    ForgotPassword: 'Forgot Password',
    ResetPassword: 'Reset Password',
    LockScreen: 'Lock Screen',
    Miscellaneous: 'Miscellaneous',
    ComingSoon: 'Coming Soon',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Not Authorized',
    Maintenance: 'Maintenance',
    Profile: 'Profile',
    User: 'User',
    View: 'View',
    Edit: 'Edit',
    UserSettings: 'User Settings',
    Invoice: 'Invoice',
    FAQ: 'FAQ',
    // Search: 'Search',
    KnowledgeBase: 'Knowledge Base',
    ChartsAndMaps: 'Charts & Maps',
    Charts: 'Charts',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Map',
    Extensions: 'Extensions',
    QuillEditor: 'Quill Editor',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Datetime Picker',
    AccessControl: 'Access Control',
    I18n: 'I18n',
    Carousel: 'Carousel',
    Clipboard: 'Clipboard',
    ContextMenu: 'Context Menu',
    StarRatings: 'Star Ratings',
    Autocomplete: 'Autocomplete',
    Tree: 'Tree',
    // "Import/Export": 'Import/Export',
    Import: 'Import',
    Export: 'Export',
    ExportSelected: 'Export Selected',
    Others: 'Others',
    MenuLevels: 'Menu Levels',
    MenuLevel2p1: 'Menu Level 2.1',
    MenuLevel2p2: 'Menu Level 2.2',
    MenuLevel3p1: 'Menu Level 3.1',
    MenuLevel3p2: 'Menu Level 3.2',
    DisabledMenu: 'Disabled Menu',
    Support: 'Support',
    Documentation: 'Documentation',
    RaiseSupport: 'Raise Support',
    demoTitle: 'Card Title',
    demoText: 'Cake sesame snaps cupcake gingerbread danish I love gingerbread. Apple pie pie jujubes chupa chups muffin halvah lollipop. Chocolate cake oat cake tiramisu marzipan sugar plum. Donut sweet pie oat cake dragée fruitcake cotton candy lemon drops.',
    language_management: 'language_management',
    settings: 'Settings',
    language: 'Language',
    expressions: 'Expressions',
    role_management: 'Role management',
    roles: 'Roles',
    page_management: 'Page management',
    pages: 'Pages',
    features: 'Features',
    year_opening_management: 'Year opening management',
    school_year: 'school year',
    school_years: 'School years',
    levels: 'Levels',
    types_of_partitions: 'Types of partitions',
    partitions: 'Partitions',
    add: 'Add',
    name: 'Name',
    activate_deactivate: 'Activate / Deactivate',
    active: 'Active ?',
    action: 'Action',
    update: 'Update',
    YES: 'YES',
    NO: 'NO',
    No_data_Available: 'No data Available',
    The_name_is_required: 'The name is required.',
    Submit: 'Submit',
    Cancel: 'Cancel',
    new: 'New',
    update_a: 'Update a',
    The_level_is_added_successfully: 'The level is added successfully.',
    The_level_is_changed_successfully: 'The level is changed successfully.',
    level: 'Level',
    The_form_is_invalid: 'The form is invalid',
    of_sur: 'of',
    Search: 'Search',
    Delete: 'Delete',
    The_level_is_actived_successfully: 'The level is actived successfully',
    The_level_is_deactived_successfully: 'The level is deactived successfully',
    partition_type: 'partition type',
    The_partition_type_is_added_successfully: 'The partition type is added successfully.',
    The_partition_type_is_changed_successfully: 'The partition type is changed successfully.',
    The_number_of_partition_is_required: 'The number of partition is required.',
    number_of_partition: 'Number of partitions',
    The_level_is_deleted_successfully: 'The level is deleted successfully.',
    Level_removal_failed: 'Level removal failed.',
    The_partition_type_is_deleted_successfully: 'The partition type is deleted successfully.',
    Partition_type_removal_failed: 'Partition type removal failed.',
    Years: 'Years',
    year: 'year',
    Year_removal_failed: 'Year removal failed.',
    The_year_is_deleted_successfully: 'The year is deleted successfully.',
    The_year_is_added_successfully: 'The year is added successfully.',
    The_year_is_changed_successfully: 'The year is changed successfully.',
    Please_close_the_current_school_year_before_opening_another: 'Please close the current school year before opening another.',
    State_of_the_school_year: 'State of the school year',
    Start_date: 'Start date',
    End_date: 'End date',
    Closing_date: 'Closing date',
    In_progress: 'In progress',
    Closed: 'Closed',
    The_server_is_not_responding: 'The server is not responding.',
    Confirm_deletion: 'Confirm deletion?',
    Confirmation: 'Confirmation',
    Confirm: 'Confirm',
    The_school_year_is_deleted_successfully: 'The school year is deleted successfully.',
    School_year_removal_failed: 'School year removal failed',
    Chat_socket_closed_unexpectedly: 'Chat socket closed unexpectedly.',
    Start_year: 'Start year',
    End_year: 'End year',
    The_start_year_is_required: 'The start year is required.',
    The_end_year_is_required: 'The end year is required.',
    The_start_date_is_required: 'The start date is required.',
    First: 'Premier',
    Second: 'Deuxième',
    Third: 'Troisième',
    Fourth: 'Quatrième',
    Fifth: 'Cinquième',
    First_1st: '1er',
    Second_2nd: '2e',
    Third_3rd: '3e',
    Fourth_4th: '4e',
    Fifth_5th: '5e',
    The_school_year_is_added_successfully: 'The school year is added successfully.',
    The_partition_type_is_required: 'The partition type is required.',
    class_management: 'Class management',
    class: 'Class',
    room: 'Room',
    The_level_is_required: 'The level is required.',
    The_code_is_required: 'The code is required.',
    code: 'Code',
    The_class_is_added_successfully: 'The class is added successfully.',
    The_class_is_changed_successfully: 'The class is changed successfully.',
    The_class_is_deleted_successfully: 'The class is deleted successfully.',
    Class_removal_failed: 'Class removal failed.',
    Filter: 'Filter',
    Filterlist: 'Filter list',
    number_of_room: 'Number of rooms',
    The_number_of_room_is_required: 'The number of room is required.',
    room_capacity: 'Room capacity',
    The_class_is_actived_successfully: 'The class is actived successfully.',
    The_class_is_deactived_successfully: 'The class is deactived successfully.',
    serie: 'Serie',
    The_serie_is_added_successfully: 'The serie is added successfully.',
    The_serie_is_changed_successfully: 'The serie is changed successfully.',
    The_serie_is_deleted_successfully: 'The serie is deleted successfully.',
    Serie_removal_failed: 'Serie removal failed.',
    The_room_is_actived_successfully: 'The room is actived successfully.',
    The_room_is_deactived_successfully: 'The room is deactived successfully.',
    The_room_capacity_is_required: 'The room capacity is required.',
    The_room_is_added_successfully: 'The room is added successfully.',
    The_room_is_changed_successfully: 'The room is changed successfully.',
    sex: 'Sex',
    The_sex_is_added_successfully: 'The sex is added successfully.',
    The_sex_is_changed_successfully: 'The sex is changed successfully.',
    The_sex_is_deleted_successfully: 'The sex is deleted successfully.',
    Sex_removal_failed: 'Sex removal failed.',
    accounting_management: 'Accounting management',
    type_of_fees: 'Type of fees',
    fees: 'Fees',
    The_type_of_fees_is_added_successfully: 'The type of fees is added successfully.',
    The_type_of_fees_is_changed_successfully: 'The type of fees is changed successfully.',
    The_number_of_slice_is_required: 'The number of slice is required.',
    number_of_slice: 'Number of slice',
    The_type_of_fees_is_deleted_successfully: 'The type of fees is deleted successfully.',
    Type_of_fees_removal_failed: 'Type of fees removal failed.',
    In_which_classes_will_you_use_this_type_of_fee: 'In which classes will you use this type of fee ?',
    Amount: 'Amount',
    The_amount_is_required: 'The amount is required.',
    The_end_date_is_required: 'The end date is required.',
    There_is_no_open_school_year: 'There is no open school year.',
    The_fees_is_added_successfully: 'The fees is added successfully.',
    Student_management: 'Student management',
    Student: 'Student',
    Parent: 'Parent',
    Personal_information: 'Personal information',
    Parent_or_guardian: 'Parent or guardian',
    School_information: 'School information',
    Student_status: 'Student status',
    Classroom: 'Classroom',
    Entry_date: 'Entry date',
    Last_name: 'Last name',
    First_names: 'First names',
    Phone_number_1: 'Phone number 1',
    Phone_number_2: 'Phone number 2',
    Address: 'Address',
    Contact: 'Contact',
    Date_of_Birth: 'Date of Birth',
    Remove_a_parent: 'Remove a parent',
    Registration_number: 'Registration number',
    The_Student_status_is_added_successfully: 'The Student status is added successfully.',
    The_Student_status_is_changed_successfully: 'The Student status is changed successfully.',
    The_Student_status_is_deleted_successfully: 'The Student status is deleted successfully.',
    Student_status_removal_failed: 'Student status removal failed.',
    Abbreviation: 'Abbreviation',
    The_abbreviation_is_required: 'The abbreviation is required.',
    The_student_is_added_successfully: 'The student is added successfully.',
    The_student_is_changed_successfully: 'The student is changed successfully.',
    The_Date_of_Birth_is_required: 'The Date of Birth is required.',
    The_sex_is_required: 'The sex is required.',
    The_Last_name_is_required: 'The Last name is required.',
    The_First_names_is_required: 'The First names is required.',
    The_Address_is_required: 'The Address is required.',
    The_Phone_number_1_is_required: 'The Phone number 1 is required.',
    The_Entry_date_is_required: 'The Entry date is required.',
    The_Student_status_is_required: 'The Student status is required.',
    The_Classroom_is_required: 'The Classroom is required.',
    full_name: 'Full name',
    The_parent_is_added_successfully: 'The parent is added successfully.',
    The_parent_is_changed_successfully: 'The parent is changed successfully.',
    Employee: 'Employee',
    Post: 'Post',
    Employee_management: 'Employee management',
    Standart_salary: 'Standart salary',
    Title_Post: 'Title Post',
    The_Title_Post_is_required: 'The Title Post is required.',
    The_Standart_salary_is_required: 'The Standart salary is required.',
    The_post_is_added_successfully: 'The post is added successfully.',
    The_post_is_changed_successfully: 'The post is changed successfully.',
    place_of_birth: 'Place of birth',
    person_to_contact: 'Person to contact',
    post_box: 'Post Box',
    city: 'City',
    district: 'District',
    Cnss_Registration_number: 'Cnss Registration number',
    Marital_status: 'Marital status',
    filiation: 'Filiation',
    number_of_people: 'Number of people',
    declared: 'Declared',
    withoutTcs: 'WithoutTcs',
    Gross_wages: 'Gross wages',
    The_place_of_birth_is_required: 'The place of birth is required.',
    The_person_to_contact_is_required: 'The person to contact is required.',
    The_post_box_is_required: 'The post box is required.',
    The_city_is_required: 'The city is required.',
    The_district_is_required: 'The district is required.',
    The_Cnss_Registration_number_is_required: 'The Cnss Registration number is required.',
    The_post_is_required: 'The post is required.',
    The_Marital_status_is_required: 'The Marital status is required.',
    The_filiation_is_required: 'The filiation is required.',
    The_number_of_people_in_charge_is_required: 'The number of people in charge is required.',
    The_Gross_wages_is_required: 'The Gross wages is required.',
    The_Marital_status_is_added_successfully: 'The Marital status is added successfully.',
    The_Marital_status_is_changed_successfully: 'The Marital status is changed successfully.',
    The_employee_is_added_successfully: 'The employee is added successfully.',
    The_employee_is_changed_successfully: 'The employee is changed successfully.',
    report_cards_management: 'Report cards management',
    occupied_position: 'Occupied position',
    matter_type: 'Matter type',
    matter: 'Matter',
    matter_by_class: 'Matter by class',
    teachers: 'Teachers',
    exam: 'Exam',
    add_exam: 'Add exam',
    exam_type: 'Exam type',
    report_card: 'Report card',
    The_exam_type_is_added_successfully: 'The exam type is added successfully.',
    The_exam_type_is_changed_successfully: 'The exam type is changed successfully.',
    The_exam_type_is_deleted_successfully: 'The exam type is deleted successfully.',
    Exam_type_removal_failed: 'Exam type removal failed.',
    The_matter_type_is_added_successfully: 'The matter type is added successfully.',
    The_matter_type_is_changed_successfully: 'The matter type is changed successfully.',
    The_matter_type_is_deleted_successfully: 'The matter type is deleted successfully.',
    Matter_type_removal_failed: 'Matter type removal failed.',
    The_matter_is_added_successfully: 'The matter is added successfully.',
    The_matter_is_changed_successfully: 'The matter is changed successfully.',
    The_matter_is_deleted_successfully: 'The matter is deleted successfully.',
    Matter_removal_failed: 'Matter removal failed.',
    coefficient: 'Coefficient',
    The_class_is_required: 'The class is required.',
    The_matter_is_required: 'The matter is required.',
    The_matter_type_is_required: 'The matter type is required.',
    The_coefficient_is_required: 'The coefficient is required.',
    The_matter_by_class_is_added_successfully: 'The matter by class is added successfully.',
    The_matter_by_class_is_changed_successfully: 'The matter by class is changed successfully.',
    Actions: 'Actions',
    multiple_add: 'Multiple add',
    The_matters_by_class_are_added_successfully: 'The matters by class are added successfully.',
    professor: 'Professor',
    This_position_is_for_teachers: 'This position is for teachers.',
    This_post_is_not_for_teachers: 'This post is not for teachers.',
    matter_by_teachers: 'Matter by teachers',
    The_matter_by_teachers_is_added_successfully: 'The matter by teachers is added successfully.',
    The_matter_by_teachers_is_changed_successfully: 'The matter by teachers is changed successfully.',
    The_matter_by_teachers_is_deleted_successfully: 'The matter by teachers is deleted successfully.',
    Matter_by_teachers_removal_failed: 'Matter by teachers removal failed.',
    The_room_is_required: 'The room is required.',
    The_Employee_is_required: 'The Employee is required.',
    The_matter_by_class_is_required: 'The matter by class is required.',
    Failure: 'Failure!',
    Success: 'Success!',
    student_by_partition: 'Student by partition',
    Dispense_from_a_matter: 'Dispense from a matter',
    partition: 'partition',
    The_student_by_partition_is_deleted_successfully: 'The student by partition is deleted successfully.',
    student_by_partition_removal_failed: 'Student by partition removal failed',
    The_student_by_partition_is_added_successfully: 'The student by partition is added successfully.',
    The_student_by_partition_is_changed_successfully: 'The student by partition is changed successfully.',
    The_Student_is_required: 'The Student is required.',
    The_partition_is_required: 'The partition is required.',
    This_registration_already_exists_Please_choose_another_registration: 'This registration already exists. Please choose another registration.',
    The_matter_by_class_is_deleted_successfully: 'The matter by class is deleted successfully.',
    The_student_by_partition_are_added_successfully: 'The student by partition are added successfully.',
    The_student_by_partition_is_actived_successfully: 'The student by partition is actived successfully.',
    The_student_by_partition_is_deactived_successfully: 'The student by partition is deactived successfully.',
    The_Dispense_from_a_matter_is_added_successfully: 'The Dispense from a matter is added successfully.',
    The_Dispense_from_a_matter_is_changed_successfully: 'The Dispense from a matter is changed successfully.',
    The_matter_by_teachers_is_required: 'The matter by teachers is required.',
    The_Dispense_from_a_matter_are_added_successfully: 'The Dispense from a matter are added successfully.',
    The_Dispense_from_a_matter_is_actived_successfully: 'The Dispense from a matter is actived successfully.',
    The_Dispense_from_a_matter_is_deactived_successfully: 'The Dispense from a matter is deactived successfully.',
    The_Dispense_from_a_matter_is_deleted_successfully: 'The Dispense from a matter is deleted successfully.',
    Dispense_from_a_matter_removal_failed: 'Dispense from a matter removal failed.',
    This_filed_is_required: 'This filed is required.',
    This_field_must_be_numeric_and_may_contain_decimal_points: 'This field must be numeric and may contain decimal points.',
    This_field_must_be_20_or_less: 'This field must be 20 or less.',
    This_field_must_be_0_or_more: 'This field must be 0 or more.',
    notes: 'Notes',
    The_type_examen_is_required: 'The type examen is required',
    Abandonment: 'Abandonment',
    Confirm_abandonment: 'Confirm abandonment',
    The_abandonment_is_saved_successfully: 'The abandonment is saved successfully',
    Abandonment_saving_failed: 'Abandonment_saving_failed',
    Abandoned: 'Abandoned',
    Waiting: 'Waiting',
    valuation_date: 'Valuation date',
    start_time: 'Start time',
    end_time: 'End time',
    The_valuation_date_is_required: 'The valuation date is required.',
    The_start_time_is_required: 'The start time is required.',
    The_end_time_is_required: 'The end time is required.',
    appreciation: 'Appreciation',
    start_number: 'Start number',
    end_number: 'End number',
    The_start_number_is_required: 'The start number is required',
    The_end_number_is_required: 'The end number is required',
    The_appreciation_is_added_successfully: 'The appreciation is added successfully',
    The_appreciation_is_changed_successfully: 'The appreciation is changed successfully',
    The_appreciation_is_required: 'The appreciation is required',
    Cancel_abandonment: 'Cancel abandonment',
    The_abandonment_is_canceled_successfully: 'The abandonment is canceled successfully',
    Abandonment_canceling_failed: 'Abandonment canceling failed',
    Update_image: 'Update image',
    Remove_image: 'Remove image',
    average: 'Average',
    rank: 'Rank',
    all_report_card: 'All report card',
    rank_by_partition: 'Rank by partition',
    annual_rank: 'Annual rank',
    induvidual_report_card: 'Induvidual report card',
    upload_report_card: 'Upload report card',
    upload: 'Upload',
    occupied_places: 'Occupied places',
    is_it_full: 'Is it full?',
    Old_report_card: 'Old report card',
    Download: 'Download',
    download_old_report_card: 'Download old report card',
    download_aproved_report_card: 'Download aproved report card',
    Assign_a_room_to_students: 'Assign a room to students',
    Remove_students_from_a_room: 'Remove students from a room',
    This_room_does_not_contain_students: 'This room does not contain students',
    Select_all: 'Select all',
    Changes_have_been_made_successfully: 'Changes have been made successfully',
    Assign_Remove_student: 'Assign / Remove student',
    Logout: 'Logout',
    The_Exam_is_added_successfully: 'The Exam is added successfully',
    The_Exam_is_changed_successfully: 'The Exam is changed successfully',
    Definition: 'Definition',
    The_picture_is_changed_successfully: 'The picture is changed successfully',
    Upload_image: 'Upload_image',
    Picture: 'Picture',
    Upload_picture: 'Upload picture',
    Students: 'Students',
    Girls: 'Girls',
    Boys: 'Boys',
    Number_of_students: 'Number of students',
    Connected: 'Connected',
    Internet: 'Internet',
    The_data_has_been_successfully_chared: 'The data has been successfully chared.',
    Not_connected: 'Not connected',
    Pending: 'Pending',
    Upload_data: 'Upload data',
    Data_loading_failed: 'Data loading failed.',
    In_good_standing: 'In good standing',
    Abandonment_pending: 'Abandonment pending',
    Total: 'Total',
    list_of_students: 'List of students',
    note_card: 'Note card',
    attendance_record: 'Attendance record',
    school: 'School',
    update_school_information: 'Update school information',
    head_of_school: 'Head of school',
    school_name: 'School_name',
    school_bp: 'School_bp',
    school_address: 'School_address',
    school_email: 'School_email',
    school_tel1: 'School_tel1',
    school_tel2: 'School_tel2',
    school_tel3: 'School_tel3',
    school_logo: 'School_logo',
    The_head_of_school_is_required: 'The head of school is required',
    The_school_name_is_required: 'The school name is required',
    The_school_bp_is_required: 'The school bp is required',
    The_school_address_is_required: 'The school address is required',
    The_school_email_is_required: 'The school email is required',
    Upload_logo: 'Upload logo',
    School_information_has_been_changed_successfully: 'School information has been changed successfully',
    Excel_file_header: 'Excel file header',
    Create_a_batch_of_students: 'Create a batch of students',
    Full_professor_per_room: 'Full professor per room',
    The_Full_professor_per_room_is_added_successfully: 'The Full professor per room is added successfully',
    The_Full_professor_per_room_is_changed_successfully: 'The Full professor per room is changed successfully',
    The_Full_professor_per_room_is_deleted_successfully: 'The Full professor per room is deleted successfully',
    This_room_already_has_a_full_professor: 'This room already has a full professor',
    short_label: 'Short label',
    long_label: 'Long label',
    Attendance: 'Attendance',
    Date: 'Date',
    Present: 'Present',
    Absent: 'Absent',
    The_Attendance_is_added_successfully: 'The Attendance is added successfully',
    The_date_is_required: 'The date is required',
    The_Attendance_is_deleted_successfully: 'The Attendance is deleted successfully',
    Attendance_removal_failed: 'Attendance removal failed',
    Date_of_attendance: 'Date of attendance',
    Upload_evidence: 'Upload evidence',
    Download_evidence: 'Download evidence',
    Old_evidence: 'Old evidence',
    The_evidence_is_changed_successfully: 'The evidence is changed successfully',
    Evidence_changing_failed: 'Evidence changing failed',
    The_partition_is_actived_successfully: 'The partition is actived successfully',
    The_partition_is_deactived_successfully: 'The partition is deactived successfully',
    Please_activate_a_partition_before_continuing: 'Please activate a partition before continuing',
    school_fees: 'School fees',
    Add_school_fees_payment: 'Add school fees payment',
    Left_to_pay: 'Left to pay',
    Total_amount: 'Total amount',
    Remaining_mount: 'Remaining amount',
    Amount_to_pay: 'Amount to pay',
    State_of_payments: 'State of payments',
    Slice: 'Slice',
    Not_solded: 'Not solded',
    Solded: 'Solded',
    Payed: 'Payed',
    This_field_must_be_less_or_equal_to_the_remaining_amount: '99999999999999999999999999999',
    Old: 'Old',
    Full_name: 'Full name',
    the_abbreviation_in_the_bulletin_is_required: 'the abbreviation in the bulletin is required',
    the_total_in_the_bulletin_is_required: 'the total in the bulletin is required',
    the_title_in_the_bulletin_is_required: 'the title in the bulletin is required',
    abbreviationBulletin: 'Report card abbreviation',
    totalBulletin: 'Report card total',
    titleBulletin: 'Report card title',
    The_Report_Card_is_changed_successfully: 'The Report Card is changed successfully',
    The_report_card_is_deleted_successfully: 'The report card is deleted successfully',
    Report_card_removal_failed: 'Report card removal failed',
    users: 'Users',
    The_payment_is_added_successfully: 'The payment is added successfully',
    Receipts: 'Receipts',
    Date_of_payment: 'Date of payement',
    etat_financier: 'État Financier',
    The_modifications_have_been_carried_out_with_successs: 'The modifications have been carried out with success.',
    Next: 'Next',
    Previous: 'Previous',
    Pre_end_of_the_year: 'Pre-end of the year',
    SMS_Messaging: 'SMS Messaging',
    Personalize: 'Personalize',
    Message_sent: 'Message sent',
    Successful_message: 'Successful message',
    Failure_message: 'Failure message',
    New_Message: 'New Message',
    Salary_management: 'Salary management',
    Banks: 'Banks',
    Premiums: 'Premiums',
    Month: 'Month',
    Employee_to_pay: 'Employee to pay'
  },
  de: {
    Dashboard: 'Instrumententafel',
    eCommerce: 'eCommerce',
    Apps: 'Apps',
    Todo: 'Machen',
    Chat: 'Plaudern',
    Email: 'Email',
    Calendar: 'Kalender',
    FullCalendar: 'Calendrier completVollständiger Kalender',
    SimpleCalendar: 'Einfacher Kalender',
    Shop: 'Geschäft',
    ItemDetails: 'Artikeldetails',
    Cart: 'Wagen',
    WishList: 'Wunschzettel',
    Checkout: 'Auschecken',
    UI: 'UI',
    DataList: 'Datenliste',
    ListView: 'Listenansicht',
    ThumbView: 'Daumenansicht',
    Grid: 'Gitter',
    ESM: 'ESM',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Farben',
    Card: 'Karte',
    Basic: 'Basic',
    Statistics: 'Statistiken',
    Analytics: 'Analytics',
    CardActions: 'Kartenaktionen',
    CardColors: 'Kartenfarben',
    Table: 'Tabelle',
    agGridTable: 'agGrid-Tabelle',
    Components: 'Komponenten',
    Alert: 'Warnen',
    Avatar: 'Benutzerbild',
    Badge: 'Abzeichen',
    Breadcrumb: 'Breadcrumb',
    Button: 'Taste',
    ButtonGroup: 'Schaltflächengruppe',
    Chip: 'Chip',
    Collapse: 'Zusammenbruch',
    Dialogs: 'Dialoge',
    Divider: 'Teiler',
    DropDown: 'Dropdown-Liste',
    List: 'Liste',
    Loading: 'Wird geladen',
    Navbar: 'Navbar',
    Notifications: 'Benachrichtigungen',
    Pagination: 'Seitennummerierung',
    Popup: 'Pop-up',
    Progress: 'Fortschritt',
    Sidebar: 'Seitenleiste',
    Slider: 'Schieberegler',
    Tabs: 'Tabs',
    Tooltip: 'QuickInfo',
    Upload: 'Hochladen',
    FormsAndTable: 'Formulare und Tabelle',
    FormElements: 'Formularelemente',
    Select: 'Wählen',
    Switch: 'Schalter',
    Checkbox: 'Ankreuzfeld',
    Radio: 'Radio',
    Input: 'Eingang',
    NumberInput: 'Nummer eingeben',
    Textarea: 'Textbereich',
    FormLayouts: 'Formularlayouts',
    FormWizard: 'Formzauberer',
    FormValidation: 'Formularvalidierung',
    FormInputGroup: 'Formulareingabegruppe',
    Pages: 'Seiten',
    Authentication: 'Authentifizierung',
    Login: 'Anmeldung',
    Register: 'Registrieren',
    ForgotPassword: 'Passwort vergessen',
    ResetPassword: 'Passwort zurücksetzen',
    LockScreen: 'Bildschirm sperren',
    Miscellaneous: 'Verschiedenes',
    ComingSoon: 'Demnächst',
    Error: 'Error',
    404: '404',
    500: '500',
    NotAuthorized: 'Nicht berechtigt',
    Maintenance: 'Instandhaltung',
    Profile: 'Profil',
    User: 'Benutzer',
    View: 'Aussicht',
    Edit: 'Bearbeiten',
    UserSettings: 'Benutzereinstellungen',
    Invoice: 'Rechnung',
    FAQ: 'FAQ',
    Search: 'Suche',
    KnowledgeBase: 'Wissensbasis',
    ChartsAndMaps: 'Diagramme und Karten',
    Charts: 'Diagramme',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Karte',
    Extensions: 'Erweiterungen',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Ziehen und loslassen',
    Datepicker: 'Datumsauswahl',
    DatetimePicker: 'Datum / Uhrzeit-Auswahl',
    AccessControl: 'Zugangskontrolle',
    I18n: 'I18n',
    Carousel: 'Karussell',
    Clipboard: 'Zwischenablage',
    ContextMenu: 'Kontextmenü',
    StarRatings: 'Sterne Bewertungen',
    Autocomplete: 'Autovervollständigung',
    Tree: 'Baum',
    // "Import/Export": 'Einführen/Export',
    Import: 'Einführen',
    Export: 'Export',
    ExportSelected: 'Auswahl exportieren',
    Others: 'Andere',
    MenuLevels: 'Menüebenen',
    MenuLevel2p1: 'Menüebene 2.1',
    MenuLevel2p2: 'Menüebene 2.2',
    MenuLevel3p1: 'Menüebene 3.1',
    MenuLevel3p2: 'Menüebene 3.2',
    DisabledMenu: 'Deaktiviertes Menü',
    Support: 'Unterstützung',
    Documentation: 'Dokumentation',
    RaiseSupport: 'Unterstützung erheben',
    demoTitle: 'Kartentitel',
    demoText: 'Kuchen Sesam Schnaps Cupcake Lebkuchen Dänisch Ich liebe Lebkuchen. Apfelkuchen-Torte-Jujuben chupa chups muffin halvah Lutscher. Schokoladenkuchenhaferkuchen Tiramisu-Marzipanzuckerpflaume. Donut süße Kuchen Hafer Kuchen Dragée Obstkuchen Zuckerwatte Zitrone Tropfen.'
  },
  fr: {
    Dashboard: 'Tableau de bord',
    eCommerce: 'commerce électronique',
    Apps: 'Applications',
    Todo: 'Faire',
    Chat: 'Bavarder',
    Email: 'Email',
    Calendar: 'Calendrier',
    FullCalendar: 'Calendrier complet',
    SimpleCalendar: 'Calendrier simple',
    Shop: 'Boutique',
    ItemDetails: 'Détails de l\'article',
    Cart: 'Chariot',
    WishList: 'Liste de souhaits',
    Checkout: 'Check-out',
    UI: 'UI',
    DataList: 'Liste de données',
    ListView: 'Voir la liste',
    ThumbView: 'Thumb View',
    Grid: 'la grille',
    ESM: 'ESM',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Couleurs',
    Card: 'Carte',
    Basic: 'De base',
    Statistics: 'Statistiques',
    Analytics: 'Analytique',
    CardActions: 'Actions de carte',
    CardColors: 'Couleurs de la carte',
    Table: 'Table',
    agGridTable: 'tableau agGrid',
    Components: 'Composants',
    Alert: 'Alerte',
    Avatar: 'Avatar',
    Badge: 'Badge',
    Breadcrumb: 'Breadcrumb',
    Button: 'Bouton',
    ButtonGroup: 'Groupe de boutons',
    Chip: 'Puce',
    Collapse: 'Effondrer',
    Dialogs: 'Dialogues',
    Divider: 'Diviseur',
    DropDown: 'Menu déroulant',
    List: 'liste',
    Loading: 'Chargement',
    Navbar: 'Barre de navigation',
    Notifications: 'Les notifications',
    Pagination: 'Pagination',
    Popup: 'Apparaitre',
    Progress: 'Le progrès',
    Sidebar: 'Barre latérale',
    Slider: 'Curseur',
    Tabs: 'Onglets',
    Tooltip: 'Info-bulle',
    Upload: 'Télécharger',
    FormsAndTable: 'Formulaires et tableau',
    FormElements: 'Éléments de formulaire',
    Select: 'Sélectionner',
    Switch: 'Commutateur',
    Checkbox: 'Case à cocher',
    Radio: 'Radio',
    Input: 'Contribution',
    NumberInput: 'Nombre d\'entrée',
    Textarea: 'Textarea',
    FormLayouts: 'Dispositions de formulaire',
    FormWizard: 'Assistant de formulaire',
    FormValidation: 'Validation du formulaire',
    FormInputGroup: 'Groupe de saisie de formulaire',
    Pages: 'Pages',
    Authentication: 'Authentification',
    Login: 'S\'identifier',
    Register: 'registre',
    ForgotPassword: 'Mot de passe oublié',
    ResetPassword: 'réinitialiser le mot de passe',
    LockScreen: 'Écran verrouillé',
    Miscellaneous: 'Divers',
    ComingSoon: 'Arrive bientôt',
    Error: 'Erreur',
    404: '404',
    500: '500',
    NotAuthorized: 'Pas autorisé',
    Maintenance: 'Entretien',
    User: 'Utilisateur',
    View: 'Vue',
    Edit: 'Modifier',
    UserSettings: 'Paramètres utilisateur',
    Invoice: 'Facture d\'achat',
    FAQ: 'FAQ',
    Search: 'Chercher',
    KnowledgeBase: 'Base de connaissances',
    ChartsAndMaps: 'Graphiques Et Cartes',
    Charts: 'Graphiques',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Carte',
    Extensions: 'Extensions',
    QuillEditor: 'Éditeur de piquants',
    DragAndDrop: 'Drag & Drop',
    Datepicker: 'Sélecteur de date',
    DatetimePicker: 'Sélecteur de date / heure',
    AccessControl: 'Contrôle d\'accès',
    I18n: 'I18n',
    Carousel: 'Carrousel',
    Clipboard: 'Presse-papiers',
    ContextMenu: 'Menu contextuel',
    StarRatings: 'Classement par étoiles',
    Autocomplete: 'Terminé automatiquement',
    Tree: 'Arbre',
    // "Import/Export": 'Importation/Exportation',
    Import: 'Importation',
    Export: 'Exportation',
    ExportSelected: 'Exporter sélectionné',
    Others: 'Autre',
    MenuLevels: 'Niveaux de menu',
    MenuLevel2p1: 'Niveau de menu 2.1',
    MenuLevel2p2: 'Niveau de menu 2.2',
    MenuLevel3p1: 'Niveau de menu 3.1',
    MenuLevel3p2: 'Niveau de menu 3.2',
    DisabledMenu: 'Menu désactivé',
    Support: 'Soutien',
    Documentation: 'Documentation',
    RaiseSupport: 'Augmenter le soutien',
    demoTitle: 'Titre de la carte',
    demoText: 'Le gâteau au sésame s\'enclenche au petit pain au pain d\'épices danois J\'adore le pain d\'épices. Tarte aux pommes et jujubes chupa chups muffin halvah sucette. Tiramisu gâteau au chocolat gâteau d\'avoine tiramisu prune sucre. Donut tarte sucrée gâteau à l\'avoine dragée gouttes de fruits gâteau au citron en barbe à papa.',
    // ------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------------
    language_management: 'Gestion des langues',
    settings: 'Paramètres',
    language: 'Langue',
    expressions: 'Expressions',
    role_management: 'Gestion des rôles',
    roles: 'Rôles',
    page_management: 'Gestion des pages',
    pages: 'Pages',
    features: 'Fonctionnalités',
    year_opening_management: 'Gestion de l\'ouverture de l\'année',
    school_year: 'Année scolaire',
    school_years: 'Années scolaires',
    levels: 'Niveaux',
    types_of_partitions: 'Types de partitions',
    partitions: 'Partitions',
    add: 'Ajouter',
    name: 'Nom',
    activate_deactivate: 'Activé / Désactivaté',
    active: 'Active ?',
    action: 'Action',
    update: 'Mettre à jour',
    YES: 'OUI',
    NO: 'NON',
    No_data_Available: 'Aucune donnée disponible',
    The_name_is_required: 'Le nom est requis',
    Submit: 'Soumettre',
    Cancel: 'Annuler',
    new: 'Nouveau',
    update_a: 'Mettre à jour un',
    The_level_is_added_successfully: 'Réussite de l\'ajout du niveau',
    The_level_is_changed_successfully: 'Réussite de la modification du niveau',
    level: 'Niveau',
    The_form_is_invalid: 'Le formulaire est invalide',
    of_sur: 'Sûr',
    Delete: 'Supprimer',
    The_level_is_actived_successfully: 'Réussite de l\'activation du niveau',
    The_level_is_deactived_successfully: 'Réussite de la désactivation du niveau',
    partition_type: 'Type partition',
    The_partition_type_is_added_successfully: 'Réussite de l\'ajout du type de partition',
    The_partition_type_is_changed_successfully: 'Réussite de la modification du type de partition',
    The_number_of_partition_is_required: 'Le nombre de partition est requis',
    number_of_partition: 'Nombre de partitions',
    The_level_is_deleted_successfully: 'Réussite de la suppression du niveau',
    Level_removal_failed: 'Echec de la suppression du niveau',
    The_partition_type_is_deleted_successfully: 'Réussite de la suppression du type de partition',
    Partition_type_removal_failed: 'Echec de la suppression du type de partition',
    Years: 'Années',
    year: 'Année',
    Year_removal_failed: 'Echec de la suppression de l\'année',
    The_year_is_deleted_successfully: 'Réussite de la suppression de l\'année',
    The_year_is_added_successfully: 'Réussite de l\'ajout de l\'année',
    The_year_is_changed_successfully: 'Réussite de la modification de l\'année',
    Please_close_the_current_school_year_before_opening_another: 'SVP Veuillez clôturer l\'année scolaire en cours avant d\'ouvrir une nouvelle',
    State_of_the_school_year: 'Etat de l\'année scolaire',
    Start_date: 'Date de début',
    End_date: 'Date de fin',
    Closing_date: 'Date de clôture',
    In_progress: 'En cours',
    Closed: 'Clôturée',
    The_server_is_not_responding: 'Le serveur ne répond pas',
    Confirm_deletion: 'Confirmer la suppression?',
    Confirmation: 'Confirmation',
    Confirm: 'Confirmer',
    The_school_year_is_deleted_successfully: 'Réussite de la suppression l\'année scolaire',
    School_year_removal_failed: 'Echec de la suppression l\'année scolaire',
    Chat_socket_closed_unexpectedly: 'Chat socket s\'est arrêté',
    Start_year: 'Année de début',
    End_year: 'Année de fin',
    The_start_year_is_required: 'L\'année de début est reuise',
    The_end_year_is_required: 'L\'année de fin est requise',
    The_start_date_is_required: 'La date de début est requise',
    First: 'Premier',
    Second: 'Deuxième',
    Third: 'Troisième',
    Fourth: 'Quatrième',
    Fifth: 'Cinquième',
    First_1st: '1er',
    Second_2nd: '2e',
    Third_3rd: '3e',
    Fourth_4th: '4e',
    Fifth_5th: '5e',
    The_school_year_is_added_successfully: 'Réussite de l\'ajout de l\'année scolaire',
    The_partition_type_is_required: 'Le type de partition est requis',
    class_management: 'Gestion des classes',
    class: 'Classe',
    room: 'Salle',
    The_level_is_required: 'Le niveau est requis',
    The_code_is_required: 'Le code est requis',
    code: 'Code',
    The_class_is_added_successfully: 'Réussite de l\'ajout de la classe',
    The_class_is_changed_successfully: 'Réussite de la modification de la classe',
    The_class_is_deleted_successfully: 'Réussite de la suppression de la classe',
    Class_removal_failed: 'Echec de la suppression de la classe',
    Filter: 'Trier',
    Filterlist: 'Liste triée',
    number_of_room: 'Nombre de salles',
    The_number_of_room_is_required: 'Le numéro de la salle est requise',
    room_capacity: 'Capacité de la salle',
    The_class_is_actived_successfully: 'Réussite de l\'activation de la classe',
    The_class_is_deactived_successfully: 'Réussite de la désactivation de la classe',
    serie: 'Série',
    The_serie_is_added_successfully: 'Réussite de l\'ajout de la série',
    The_serie_is_changed_successfully: 'Réussite de la modification de la série',
    The_serie_is_deleted_successfully: 'Réussite de la suppression de la série',
    Serie_removal_failed: 'Echec de la suppression de la série',
    The_room_is_actived_successfully: 'Réussite de la l\'activation de la salle',
    The_room_is_deactived_successfully: 'Réussite de la désactivation de la salle',
    The_room_capacity_is_required: 'La capacité de la salle est requise',
    The_room_is_added_successfully: 'Réussite de l\'ajout de la salle',
    The_room_is_changed_successfully: 'Réussite de la modification de la salle',
    sex: 'Sexe',
    The_sex_is_added_successfully: 'Réussite de la suppression du sexe',
    The_sex_is_changed_successfully: 'Réussite de la modification du sexe',
    The_sex_is_deleted_successfully: 'Réussite de la suppression du sexe',
    Sex_removal_failed: 'Echec de la suppression du sexe',
    accounting_management: 'Gestion comptable',
    type_of_fees: 'Type de frais',
    fees: 'Frais',
    The_type_of_fees_is_added_successfully: 'Réussite de l\'ajout du type de frais',
    The_type_of_fees_is_changed_successfully: 'Réussite de la modification du type de frais',
    The_number_of_slice_is_required: 'Le nombre de tranche est requis',
    number_of_slice: 'Nombre de tranche',
    The_type_of_fees_is_deleted_successfully: 'Réussite de la suppression du type de frais',
    Type_of_fees_removal_failed: 'Echec de la suppression du type de frais',
    In_which_classes_will_you_use_this_type_of_fee: 'Pour quelles classes est ce type de frais?',
    Amount: 'Montant',
    The_amount_is_required: 'Le montant est requis',
    The_end_date_is_required: 'La date de fin est requise',
    There_is_no_open_school_year: 'Aucune année scolaire ouverte',
    The_fees_is_added_successfully: 'Réussite de l\'ajout des frais',
    Student_management: 'Gestion des élèves',
    Student: 'Elève',
    Parent: 'Parent',
    Personal_information: 'Informations personnelles',
    Parent_or_guardian: 'Parent ou tuteur',
    School_information: 'Information scolaire',
    Student_status: 'Statut de l\'élève',
    Classroom: 'Classe',
    Entry_date: 'Date d\'entrée',
    Last_name: 'Nom',
    First_names: 'Prénoms',
    Phone_number_1: 'N° Téléphone 1',
    Phone_number_2: 'N° Téléphone 2',
    Address: 'Adresse',
    Contact: 'Contact',
    Date_of_Birth: 'Date de naissance',
    Remove_a_parent: 'Supprimer un parent',
    Registration_number: 'Numéro d\'enregistrement',
    The_Student_status_is_added_successfully: 'Réussite de l\'ajout du statut de l\'élève',
    The_Student_status_is_changed_successfully: 'Réussite de la modification du statut de l\'élève',
    The_Student_status_is_deleted_successfully: 'Réussite de la suppression du statut de l\'élève',
    Student_status_removal_failed: 'Echec de la suppression de l\'élève',
    Abbreviation: 'Abréviation',
    The_abbreviation_is_required: 'L\'abréviation est requise',
    The_student_is_added_successfully: 'Réussite de l\'ajout de l\'élève',
    The_student_is_changed_successfully: 'Réussite de la modification de l\'élève',
    The_Date_of_Birth_is_required: 'La date de naissance est requise',
    The_sex_is_required: 'Le sex est requis',
    The_Last_name_is_required: 'Le nom est requis',
    The_First_names_is_required: 'Les prénoms sont requis',
    The_Address_is_required: 'L\'adresse est requise',
    The_Phone_number_1_is_required: 'Le numéro de téléphone 1 est requise',
    The_Entry_date_is_required: 'La date d\'entrée est requise',
    The_Student_status_is_required: 'Le statut de l\'élève est requis',
    The_Classroom_is_required: 'La classe est requise',
    full_name: 'Nom complet',
    The_parent_is_added_successfully: 'Réussite l\'ajout du parent',
    The_parent_is_changed_successfully: 'Réussite de la modification du parent',
    Employee: 'Employé',
    Post: 'Poste',
    Employee_management: 'Gestion des employés',
    Standart_salary: 'Salaire standard',
    Title_Post: 'Libellé',
    The_Title_Post_is_required: 'Le libellé du poste est requis',
    The_Standart_salary_is_required: 'Le salaire standard est requis',
    The_post_is_added_successfully: 'Réussite de l\'ajout du poste',
    The_post_is_changed_successfully: 'Réussite de la modification du poste',
    place_of_birth: 'Lieu de niassance',
    person_to_contact: 'Personne à contacter',
    post_box: 'Boîte postale',
    city: 'Ville',
    district: 'Quartier',
    Cnss_Registration_number: 'Numéro d\'enregistrement CNSS',
    Marital_status: 'Statut matrimonial',
    filiation: 'Filiation',
    number_of_people: 'Nombre de personnes',
    declared: 'Déclaré',
    withoutTcs: 'Sans TCS',
    Gross_wages: 'Salaire brut',
    The_place_of_birth_is_required: 'Le lieu de naissance est requis',
    The_person_to_contact_is_required: 'La personne à contacter est requise',
    The_post_box_is_required: 'La boîte postale est requise',
    The_city_is_required: 'La ville est requise',
    The_district_is_required: 'Le quartier est requis',
    The_Cnss_Registration_number_is_required: 'Le numéro CNSS est requis',
    The_post_is_required: 'Le poste est requis',
    The_Marital_status_is_required: 'Le statut matrimonial est requi',
    The_filiation_is_required: 'La filiation est requis',
    The_number_of_people_in_charge_is_required: 'Le nombre de personnes en charge est requis',
    The_Gross_wages_is_required: 'Le salaire brut est requis',
    The_Marital_status_is_added_successfully: 'Réussite de l\'ajout du statut matrimonial',
    The_Marital_status_is_changed_successfully: 'Réussite de la modification du statut matrimonial',
    The_employee_is_added_successfully: 'Réussite de l\'ajout de l\'employé',
    The_employee_is_changed_successfully: 'Réussite de la modification de l\'employé',
    report_cards_management: 'Gestion des bulletins',
    occupied_position: 'Position occupée',
    matter_type: 'Type matière',
    matter: 'Matière',
    matter_by_class: 'Matière par classe',
    matter_by_class_multiple_add: 'Matière par classe ajout multiple',
    teachers: 'Enseignants',
    exam: 'Examen',
    add_exam: 'Ajouter un examen',
    exam_type: 'Type d\'examen',
    report_card: 'Bulletin',
    The_exam_type_is_added_successfully: 'Réussite de l\'ajout du type examen',
    The_exam_type_is_changed_successfully: 'Réussite de la modification  du type examen',
    The_exam_type_is_deleted_successfully: 'Réussite de la suppression du type examen',
    Exam_type_removal_failed: 'Echec de la suppression du type examen',
    The_matter_type_is_added_successfully: 'Réussite de l\'ajout du type matière',
    The_matter_type_is_changed_successfully: 'Réussite de la modification du type matière',
    The_matter_type_is_deleted_successfully: 'Réussite de la suppression du type matière',
    Matter_type_removal_failed: 'Echec de la suppression du type matière',
    The_matter_is_added_successfully: 'Réussite de l\'ajout de la matière',
    The_matter_is_changed_successfully: 'Réussite de la modification de la matière',
    The_matter_is_deleted_successfully: 'Réussite de la suppression de la matière',
    Matter_removal_failed: 'Echec de la suppression de la matière',
    coefficient: 'Coefficient',
    The_class_is_required: 'La classe est requise',
    The_matter_is_required: 'La matière est requise',
    The_matter_type_is_required: 'Le type matière est requis',
    The_coefficient_is_required: 'Le coefficient est requis',
    The_matter_by_class_is_added_successfully: 'Réussite de l\'ajout de la matière par classe',
    The_matter_by_class_is_changed_successfully: 'Réussite de la modification  de la matière par classe',
    Actions: 'Actions',
    multiple_add: 'Ajout multiple',
    The_matters_by_class_are_added_successfully: 'Réussite de l\'ajout des matières par classe',
    professor: 'Professeur',
    This_position_is_for_teachers: 'Ce poste est pour les enseignants',
    This_post_is_not_for_teachers: 'Ce poste n\'est pas pour les enseignants',
    matter_by_teachers: 'Matière par enseignants',
    The_matter_by_teachers_is_added_successfully: 'Réussite de l\'ajout de matière par enseignant',
    The_matter_by_teachers_is_changed_successfully: 'Réussite de la modification de matière par enseignant',
    The_matter_by_teachers_is_deleted_successfully: 'Réussite de la suppression de matière par enseignant',
    Matter_by_teachers_removal_failed: 'Echec de  suppression des matières par enseignats',
    The_room_is_required: 'La salle est requise',
    The_Employee_is_required: 'L\'employé est requis',
    The_matter_by_class_is_required: 'La matière par classe est requise',
    Failure: 'Echec',
    Success: 'Réussite',
    student_by_partition: 'Elève par partition',
    Dispense_from_a_matter: 'Dispenser d\'une matière',
    partition: 'Partition',
    The_student_by_partition_is_deleted_successfully: 'Réussite de la suppression de l\'élève par partition',
    student_by_partition_removal_failed: 'Echec de la suppression de l\'élève par partition',
    The_student_by_partition_is_added_successfully: 'Réussite de l\'ajout de l\'élève par partition',
    The_student_by_partition_is_changed_successfully: 'Réussite de la modification de l\'élève par partition',
    The_Student_is_required: 'L\'élève est requis',
    The_partition_is_required: 'La partition est requise',
    This_registration_already_exists_Please_choose_another_registration: '"Cette inscription existe déjà',
    The_matter_by_class_is_deleted_successfully: 'Réussite de la suppression de la matière par classe',
    The_student_by_partition_are_added_successfully: 'Réussite de l\'ajout des élèves par partition',
    The_student_by_partition_is_actived_successfully: 'Réussite de l\'activation de l\'élève par partition',
    The_student_by_partition_is_deactived_successfully: 'Réussite de la désactivation de l\'élève par partition',
    The_Dispense_from_a_matter_is_added_successfully: 'Réussite de l\'ajout de la dispense de matière',
    The_Dispense_from_a_matter_is_changed_successfully: 'Réussite de la modification de la dispense de matière',
    The_matter_by_teachers_is_required: 'La matière par enseignants est requise',
    The_Dispense_from_a_matter_are_added_successfully: 'Réussite de l\'ajout des dispenses de matière',
    The_Dispense_from_a_matter_is_actived_successfully: 'Réussite de l\'activation de la dispense de matière',
    The_Dispense_from_a_matter_is_deactived_successfully: 'Réussite de la désactivation de la dispense de matière',
    The_Dispense_from_a_matter_is_deleted_successfully: 'Réussite de la suppression de la dispense de matière',
    Dispense_from_a_matter_removal_failed: 'Echec de la suppression de la dispense de matière',
    This_filed_is_required: 'Ce champ est requis',
    This_field_must_be_numeric_and_may_contain_decimal_points: 'La valeur doit être un nombre entier ou décimal',
    This_field_must_be_20_or_less: 'La valeur doit est inférieure ou égale à 20',
    This_field_must_be_0_or_more: 'La valeur doit est supérieure ou égale à 0',
    notes: 'Notes',
    The_type_examen_is_required: 'Le type d\'examen est requis',
    Abandonment: 'Abandon',
    Confirm_abandonment: 'Confirmer l\'abandon',
    The_abandonment_is_saved_successfully: 'Réussite de l\'enregistrement de l\'abandon',
    Abandonment_saving_failed: 'Echec de l\'enregistrement de l\'abandon',
    Abandoned: 'Abandonné',
    Waiting: 'En attente',
    valuation_date: 'Date d\'évaluation',
    start_time: 'Heure de début',
    end_time: 'Heure de fin',
    The_valuation_date_is_required: 'La date d\'évaluation est requise',
    The_start_time_is_required: 'L\'heure de début est requise',
    The_end_time_is_required: 'L\'heure de fin est requise',
    appreciation: 'Appréciation',
    start_number: 'Numéro de début',
    end_number: 'Numéro de fin',
    The_start_number_is_required: 'Le numéro de début est requis',
    The_end_number_is_required: 'Le numéro de fin est requis',
    The_appreciation_is_added_successfully: 'Réussite de l\'ajout de l\'appréciation',
    The_appreciation_is_changed_successfully: 'Réussite de la modification de l\'appréciation',
    The_appreciation_is_required: 'L\'appréciation est requise',
    Cancel_abandonment: 'Annuler l\'abandon',
    The_abandonment_is_canceled_successfully: 'Réussite de l\'annulation de l\'abandon',
    Abandonment_canceling_failed: 'Echec de l\'annulation de l\'abandon',
    Update_image: 'Modifier l\'image',
    Remove_image: 'Retirer l\'image',
    Profile: 'Profil',
    average: 'Moyenne',
    rank: 'Rang',
    all_report_card: 'Tous les bulletins de notes',
    rank_by_partition: 'Rang par partitiion',
    annual_rank: 'Rang annuel',
    induvidual_report_card: 'Bulletin de notes individuel',
    upload_report_card: 'Téléverser un bulletin de notes',
    upload: 'Téléverser',
    occupied_places: 'Places occupées',
    is_it_full: 'Est-elle pleine?',
    Old_report_card: 'Ancien bulletin de notes',
    Download: 'Télécharger',
    download_old_report_card: 'Télécharger l\'ancien bulletin de notes',
    download_aproved_report_card: 'Télécharger le bulletin de notes approuvé',
    Assign_a_room_to_students: 'Attribuer une salle aux élèves',
    Remove_students_from_a_room: 'Retirer les élèves de cette salle',
    This_room_does_not_contain_students: 'Cette salle ne contient pas d\'élèves',
    Select_all: 'Tout sélectionné',
    Changes_have_been_made_successfully: 'Modifications effectuées avec succès',
    Assign_Remove_student: 'Attribuer / Retirer un élève',
    Logout: 'Déconnexion',
    The_Exam_is_added_successfully: 'Réussite de l\'ajout de l\'exam',
    The_Exam_is_changed_successfully: 'Réussite de la modification de l\'examen',
    Definition: 'Définition',
    The_picture_is_changed_successfully: 'Réussite de la modification de l\'image',
    Upload_image: 'Choisir une image',
    Picture: 'Image',
    Upload_picture: 'Choisir une image',
    Students: 'Élèves',
    Girls: 'Filles',
    Boys: 'Garçons',
    Number_of_students: 'Nombre d\'étudiants',
    Connected: 'Connecté',
    Internet: 'Internet',
    Not_connected: 'Pas connecté',
    The_data_has_been_successfully_chared: 'Les données ont été chargées avec succès.',
    Pending: 'En attente',
    Upload_data: 'Charger des données',
    In_good_standing: 'En règle',
    Data_loading_failed: 'Le chargement des données a échoué.',
    Abandonment_pending: 'Abandon en attente',
    Total: 'Total',
    list_of_students: 'Liste des élèves',
    note_card: 'Fiche de note',
    attendance_record: 'Fiche de présence',
    school: 'École',
    update_school_information: 'Modifier les informations de l\'école',
    head_of_school: 'Directeur de l\'école',
    school_name: 'Nom de l\'école',
    school_bp: 'Boîte postale de l\'école',
    school_address: 'Adresse de l\'école',
    school_email: 'Email de l\'école',
    school_tel1: 'Numéro de téléphone 1 de l\'école',
    school_tel2: 'Numéro de téléphone 2 de l\'école',
    school_tel3: 'Numéro de téléphone 3 de l\'école',
    school_logo: 'Logo de l\'école',
    The_head_of_school_is_required: 'Le directeur de l\'école est requis',
    The_school_name_is_required: 'Le nom de l\'école est requis',
    The_school_bp_is_required: 'La boîte postale de l\'école est requise',
    The_school_address_is_required: 'L\'adresse de l\'école est requise',
    The_school_email_is_required: 'L\'email de l\'école est requis',
    Upload_logo: 'Téléverser un logo',
    School_information_has_been_changed_successfully: 'Les informations de l\'école ont été modifiées avec succès',
    Excel_file_header: 'Entête du fichier Excel',
    Create_a_batch_of_students: 'Créer un lot d\'étudiants',
    Full_professor_per_room: 'Professeur titulaire par salle',
    The_Full_professor_per_room_is_added_successfully: 'Réussite de l\'ajout du professeur titulaire par salle',
    The_Full_professor_per_room_is_changed_successfully: 'Réussite de la modification du professeur titulaire par salle',
    The_Full_professor_per_room_is_deleted_successfully: 'Réussite de la suppression du professeur titulaire par salle',
    This_room_already_has_a_full_professor: 'Cette salle a déjà un professeur titulaire',
    short_label: 'Libellé court',
    long_label: 'Libellé long',
    Attendance: 'Présence',
    Date: 'Date',
    Present: 'Présent',
    Absent: 'Absent',
    The_Attendance_is_added_successfully: 'Réussite de l\'ajout de la présence',
    The_date_is_required: 'La date est requise',
    The_Attendance_is_deleted_successfully: 'Réussite de la suppression de la présence',
    Attendance_removal_failed: 'Échec de la suppression de la présence',
    Date_of_attendance: 'Date de présence',
    Upload_evidence: 'Téléverser une preuve',
    Download_evidence: 'Télécharger une preuve',
    Old_evidence: 'Ancienne preuve',
    The_evidence_is_changed_successfully: 'Réussite de modification de la preuve',
    Evidence_changing_failed: 'Échec de modification de la preuve',
    The_partition_is_actived_successfully: 'La partition est activée avec succès',
    The_partition_is_deactived_successfully: 'La partition est désactivée avec succès',
    Please_activate_a_partition_before_continuing: 'Svp activez une partition avant de continuer',
    school_fees: 'Frais de scolarité',
    Add_school_fees_payment: 'Ajouter un paiement de frais de scolarité',
    Left_to_pay: 'Reste à payer',
    Total_amount: 'Montant total',
    Remaining_mount: 'Montant restant',
    Amount_to_pay: 'Montant à payer',
    State_of_payments: 'État des paiements',
    Slice: 'Tranche',
    Not_solded: 'Pas soldé',
    Solded: 'Soldé',
    Payed: 'Payé',
    This_field_must_be_less_or_equal_to_the_remaining_amount: 'La valeur doit être inférieure ou égale au montant restant',
    Old: 'Ancien',
    Full_name: 'Full name',
    the_abbreviation_in_the_bulletin_is_required: 'the abbreviation in the bulletin is required',
    the_total_in_the_bulletin_is_required: 'the total in the bulletin is required',
    the_title_in_the_bulletin_is_required: 'the title in the bulletin is required',
    abbreviationBulletin: 'Report card abbreviation',
    totalBulletin: 'Report card total',
    titleBulletin: 'Report card title',
    The_Report_Card_is_changed_successfully: 'The Report Card is changed successfully',
    The_report_card_is_deleted_successfully: 'The report card is deleted successfully',
    Report_card_removal_failed: 'Report card removal failed',
    users: 'Utilisateurs',
    The_payment_is_added_successfully: 'The payment is added successfully',
    Receipts: 'Reçu',
    Date_of_payment: 'Date of payement',
    etat_financier: 'État Financier',
    The_modifications_have_been_carried_out_with_successs: 'Les modifications ont été effectuées avec succès.',
    Next: 'Suivante',
    Previous: 'Précédente',
    Pre_end_of_the_year: 'Pré-clôture de l\'année',
    SMS_Messaging: 'Messagerie SMS',
    Personalize: 'Personnaliser',
    Message_sent: 'Message envoyé',
    Successful_message: 'Message abouti',
    Failure_message: 'Message non abouti',
    New_Message: 'Nouveau Message',
    Salary_management: 'Gestion des salaires',
    Banks: 'Banques',
    Premiums: 'Primes',
    Month: 'Mois',
    Employee_to_pay: 'Employé à payer',
    Change_class: 'Changer de classe'
    
  },
  pt: {
    Dashboard: 'painel de controle',
    eCommerce: 'comércio eletrônico',
    Apps: 'APPS',
    Todo: 'Façam',
    Chat: 'Bate-papo',
    Email: 'O email',
    Calendar: 'Calendário',
    FullCalendar: 'Calendário Completo',
    SimpleCalendar: 'Calendário Simples',
    Shop: 'fazer compras',
    ItemDetails: 'Detalhes do item',
    Cart: 'Carrinho',
    WishList: 'Lista de Desejos',
    Checkout: 'Confira',
    UI: 'UI',
    DataList: 'Lista de dados',
    ListView: 'Exibição de lista',
    ThumbView: 'Thumb View',
    Grid: 'Grade',
    ESM: 'ESM',
    Vuesax: 'Vuesax',
    Tailwind: 'Tailwind',
    Colors: 'Cores',
    Card: 'Cartão',
    Basic: 'Basic',
    Statistics: 'Estatisticas',
    Analytics: 'Analytics',
    CardActions: 'Ações do Cartão',
    CardColors: 'Cores do cartão',
    Table: 'Mesa',
    agGridTable: 'Tabela AgGrid',
    Components: 'Componentes',
    Alert: 'Alerta',
    Avatar: 'Avatar',
    Badge: 'Crachá',
    Breadcrumb: 'Breadcrumb',
    Button: 'Botão',
    ButtonGroup: 'Grupo de botões',
    Chip: 'Lasca',
    Collapse: 'Colapso',
    Dialogs: 'Diálogos',
    Divider: 'Divisor',
    DropDown: 'Suspenso',
    List: 'Lista',
    Loading: 'Carregando',
    Navbar: 'Navbar',
    Notifications: 'Notificações',
    Pagination: 'Paginação',
    Popup: 'Aparecer',
    Progress: 'Progresso',
    Sidebar: 'Barra Lateral',
    Slider: 'Controle Deslizante',
    Tabs: 'Guias',
    Tooltip: 'dica de ferramenta',
    Upload: 'Envio',
    FormsAndTable: 'Formulários e tabela',
    FormElements: 'Elementos do formulário',
    Select: 'Selecione',
    Switch: 'Interruptor',
    Checkbox: 'Caixa de seleção',
    Radio: 'Rádio',
    Input: 'Entrada',
    NumberInput: 'Entrada numérica',
    Textarea: 'Textarea',
    FormLayouts: 'Layouts de formulário',
    FormWizard: 'Assistente de Formulário',
    FormValidation: 'Validação de Formulário',
    FormInputGroup: 'Grupo de entrada de formulário',
    Pages: 'PÁGINAS',
    Authentication: 'Autenticação',
    Login: 'Entrar',
    Register: 'Registo',
    ForgotPassword: 'Esqueceu A Senha',
    ResetPassword: 'Redefinir Senha',
    LockScreen: 'Tela de bloqueio',
    Miscellaneous: 'Diversos',
    ComingSoon: 'Em breve',
    Error: 'Erro',
    404: '404',
    500: '500',
    NotAuthorized: 'Não autorizado',
    Maintenance: 'Manutenção',
    Profile: 'Perfil',
    User: 'Do utilizador',
    View: 'Visão',
    Edit: 'Editar',
    UserSettings: 'Configurações do Usuário',
    Invoice: 'Fatura',
    FAQ: 'Perguntas frequentes',
    Search: 'Procurar',
    KnowledgeBase: 'Base de Conhecimento',
    ChartsAndMaps: 'Gráficos E Mapas',
    Charts: 'Gráficos',
    ApexCharts: 'Apex Charts',
    chartjs: 'chartjs',
    echarts: 'echarts',
    chartist: 'chartist',
    GoogleMap: 'Google Mapa',
    Extensions: 'Extensão',
    QuillEditor: 'Quill-Editor',
    DragAndDrop: 'Arraste e solte',
    Datepicker: 'Datepicker',
    DatetimePicker: 'Seletor de data e hora',
    AccessControl: 'Controle de acesso',
    I18n: 'I18n',
    Carousel: 'Carrossel',
    Clipboard: 'Prancheta',
    ContextMenu: 'Menu contextual',
    StarRatings: 'Classificações por estrelas',
    Autocomplete: 'autocompletar',
    Tree: 'Árvore',
    // "Import/Export": 'Importar/Exportar',
    Import: 'Importar',
    Export: 'Exportar',
    ExportSelected: 'Exportar Selecionado',
    Others: 'Outras',
    MenuLevels: 'Níveis de Menu',
    MenuLevel2p1: 'Nível de menu 2.1',
    MenuLevel2p2: 'Nível de menu 2.2',
    MenuLevel3p1: 'Nível de menu 3.1',
    MenuLevel3p2: 'Nível de menu 3.2',
    DisabledMenu: 'Menu desativado',
    Support: 'Apoio, suporte',
    Documentation: 'Documentação',
    RaiseSupport: 'Levantar Suporte',
    demoTitle: 'Título do cartão',
    demoText: 'O sésamo do bolo agarra dinamarquês do pão-de-espécie do queque eu amo o pão-de-espécie. Torta de torta de maçã jujuba chupa chups muffin halvah pirulito. Ameixa do açúcar do maçapão do tiramisu do bolo da aveia do bolo de chocolate. Bolo de aveia de torta doce rosquinha dragée fruitcake algodão doce gotas de limão.'
  }
}

if (i18nDataForESM) {
  Object.assign(old_language.en, i18nDataForESM.en)
  // Object.assign(old_language.fr, i18nDataForESM.en)
}

export default old_language
